import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'

import { markFirebaseReady } from './lazy'

const firebaseConfig = {
  apiKey: process.env.PUBLIC_FIREBASE_API_KEY,
  authDomain: 'recallalerts-95fc4.firebaseapp.com',
  databaseURL: 'https://recallalerts-95fc4.firebaseio.com',
  projectId: 'recallalerts-95fc4',
  storageBucket: 'recallalerts-95fc4.appspot.com',
  messagingSenderId: '335105441538',
  appId: '1:335105441538:web:29a992ce37968ccc',
}

export function getFirebaseApp(): firebase.app.App {
  const existing = firebase.apps[0]
  if (existing) {
    return existing
  }
  const app = firebase.initializeApp(firebaseConfig)
  markFirebaseReady(app)
  return app
}
